import { Item } from "dsabp-js"
import { createCanvas } from "../canvas.js"
import { rendererResolvers } from "../main.js"
import { getImage, toImage } from "../util.js"

rendererResolvers.push(
	({ item, other }) => {
		if (item != Item.ITEM_EJECTOR)
			return

		const hullDirection = other.hullDirection

		return {
			discriminator: `${item.id}${hullDirection ? "" : "_c"}`,
			async render() {
				const imgMount = await getImage("hull_mount")
				const imgEjector = await getImage("item_ejector_compact")				

				const canvas = createCanvas(imgEjector.width, (hullDirection ? imgMount : imgEjector).height)
				const ctx = canvas.getContext("2d")
				if (hullDirection) 
					ctx.drawImage(imgMount, 0, 0)
				ctx.drawImage(imgEjector, 0, hullDirection ? 40 : 0)

				return [{
					image: await toImage(canvas),
					...(hullDirection ? {
						baseBoundOff: { x: 0.2, y: 0.2 }
					} : null)
				}]
			}
		}
	}
)
